import styled, { keyframes } from 'styled-components/macro';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 20px;
`;

export const Content = styled.div`
  position: relative;
  background: linear-gradient(135deg, #1a1a1a 0%, #0d0d0d 100%);
  border-radius: 16px;
  padding: 40px;
  max-width: 1200px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(21, 215, 27, 0.5);
    border-radius: 4px;

    &:hover {
      background: rgba(21, 215, 27, 0.7);
    }
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  font-size: 24px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 10;

  &:hover {
    background: rgba(21, 215, 27, 0.3);
    transform: rotate(90deg);
  }
`;

export const FrameImage = styled.img`
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  border: 3px solid #15d71b;
`;

export const ProductsSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-height: 70vh;
  overflow-y: auto;
  padding-right: 10px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(21, 215, 27, 0.5);
    border-radius: 3px;

    &:hover {
      background: rgba(21, 215, 27, 0.7);
    }
  }
`;

export const SectionTitle = styled.h2`
  color: white;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
  padding-bottom: 10px;
`;

export const ProductCard = styled.div`
  display: flex;
  gap: 15px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);
  padding: 15px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    background: linear-gradient(135deg, rgba(21, 215, 27, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);
    border-color: rgba(21, 215, 27, 0.5);
    box-shadow: 0 4px 15px rgba(21, 215, 27, 0.2);
  }
`;

export const ProductImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ProductInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: center;
`;

export const ProductTitle = styled.h3`
  color: white;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;

export const ProductPrice = styled.div`
  color: #15d71b;
  font-size: 16px;
  font-weight: 700;
`;

export const ProductLink = styled.a`
  display: inline-block;
  padding: 6px 16px;
  background: linear-gradient(135deg, #15d71b 0%, #0ea356 100%);
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  width: fit-content;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(21, 215, 27, 0.4);
    background: linear-gradient(135deg, #0ea356 0%, #15d71b 100%);
  }
`;

export const QRColumn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

export const QRImage = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 8px;
  background: white;
  padding: 4px;
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Spinner = styled.div`
  border: 3px solid rgba(21, 215, 27, 0.2);
  border-top: 3px solid #15d71b;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: ${spin} 1s linear infinite;
  margin: 0 auto;
`;

export const EmptyMessage = styled.div`
  color: #999;
  text-align: center;
  padding: 40px 20px;
  fontsize: 14px;
`;
